import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Input } from 'antd';

import { MultipleSelect } from '@app/components';
import { MIN_THREE_SYMBOLS } from '@app/constants';
import type { FiltersForm } from '@app/pages/Warehouses/WarehouseRegistry/types';

import type { FormInstance } from 'antd';
import type { BaseOptionType } from 'antd/es/select';
import type { FC } from 'react';

import '@pages/Warehouses/WarehouseRegistry/ui/WarehousesRegistryFilters.scss';

const { Item } = Form;

interface WarehousesRegistryFiltersProps {
  filtersForm: FormInstance<FiltersForm>;
  selectedBranches: BaseOptionType[];
  setSelectedBranches: React.Dispatch<React.SetStateAction<BaseOptionType[]>>;
  allBranches: BaseOptionType[];
  handleSearch: (values: FiltersForm) => void;
  resetSearch: () => void;
}

export const WarehousesRegistryFilters: FC<WarehousesRegistryFiltersProps> = ({
  filtersForm,
  selectedBranches,
  setSelectedBranches,
  allBranches,
  handleSearch,
  resetSearch,
}) => {
  return (
    <Form
      form={filtersForm}
      onFinish={handleSearch}
      autoComplete="off"
      className="WarehousesRegistryFilters"
    >
      <Flex gap={10} vertical className="WarehousesRegistryFilters__content">
        <Item
          name="SearchTerm"
          rules={[{ min: 3, message: MIN_THREE_SYMBOLS }]}
          className="WarehousesRegistryFilters__search"
        >
          <Input
            placeholder="Введите наименование склада"
            addonBefore={<SearchOutlined />}
          />
        </Item>
        <Flex
          justify="space-between"
          wrap
          gap={16}
          className="WarehousesRegistryFilters__toolbar"
        >
          <MultipleSelect
            className="WarehousesRegistryFilters__branches"
            placeholder="Все филиалы"
            allOptions={allBranches}
            width={260}
            minWidth={260}
            selectedOption={selectedBranches}
            setSelectedOptions={setSelectedBranches}
          />

          <div className={'WarehousesRegistryFilters__buttons'}>
            <Button
              htmlType="reset"
              onClick={resetSearch}
              className={'WarehousesRegistryFilters__buttons_item'}
            >
              <CloseCircleOutlined />
              Сброс
            </Button>
            <Button
              type="primary"
              onClick={filtersForm.submit}
              className={'WarehousesRegistryFilters__buttons_item'}
            >
              Показать
            </Button>
          </div>
        </Flex>
      </Flex>
    </Form>
  );
};
